 export const StringUtil = { 
    replaceCostPoint : ( value: string ) => {
      var cpString = value?.replace("cost point","Costpoint")
      return cpString?.replace("Cost Point","Costpoint");
    },
}